export const fbaUnits = {
  t_r: '°C',
  c_f: '1/kPa',
  formationCompressibility: '1/kPa',
  gor: 'm3/m3',
  cgr: 'm3/E6m3',
  p_fi: 'kPa',
  pbtMatrixInflow: 'kPa',
  pSep: 'kPa',
  h: 'm',
  r_w: 'm',
  id: 'mm',
  w_f: 'mm',
  roughness: 'mm',
  geothermalGradient: '°C / 100 m',
  wht: '°C',
  tSep: '°C',
  rB: 'm3/m3',
  midPointPerfs: 'm',
  fractureConductivityLFTC: 'md-m',
  fractureConductivityPreBT: 'md-m',
  fc: 'm',
  fractureConductivity: 'md-m',
  loadFluidPumped: 'm3',
  drainageAreaPreBT: 'm2',
  drainageAreaPostBT: 'm2',
  fractureArea: 'm2',
  fip: 'm3',
  fractureSpacingMatrixInflow: 'm',
  oil: 'm3',
  gas: 'E3m3',
  water: 'm3',
  pwh: 'kPa',
  pwf: 'kPa'
};